// MSAL configuration for Azure Entra External ID (Azure AD B2C) or External Tenant
// TODO: Replace placeholders with your tenant and app registration details.

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "<YOUR_CLIENT_ID>",
    // For External Identities (B2C), use your user flow authority.
    // Example: https://yourtenant.b2clogin.com/yourtenant.onmicrosoft.com/B2C_1_signin
    authority:
      process.env.REACT_APP_AZURE_AUTHORITY ||
      "https://<yourtenant>.b2clogin.com/<yourtenant>.onmicrosoft.com/<your_user_flow>",
    knownAuthorities: [
      process.env.REACT_APP_AZURE_KNOWN_AUTHORITY ||
        "<yourtenant>.b2clogin.com",
    ],
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      process.env.REACT_APP_POSTLOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false, // set true if you need IE11/legacy support
  },
};

// Default login request scopes (OIDC)
export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
};

// Helper to preselect Google IdP in B2C (update the idp value to match your IdP ID if different)
export const googleIdpHint = { extraQueryParameters: { idp: "Google" } };
